<div class="container-summary-wrapper">

    <div
        id="container-summary-modal-close-button"
        class="tryb-modal-close-button"
        (click)="closeModal()"
        (mouseenter)="isCloseButtonHovered = true"
        (mouseleave)="isCloseButtonHovered = false"
    >
        <img
            [src]="
                'assets/svg/reusable-svg/close' +
                (isCloseButtonHovered ? '-hover' : '') +
                '.svg'
            "
            alt="close-icon"
        />
    </div>

    <div class="container-summary-inner-container" [ngClass]="{isLoading: isLoading}">
        <div class="container-type-information-wrapper">
            <div class="container-type-information-icon-container">
                <img [src]="containerIconPathByContainerType.get(container?.containerType)"
                     [alt]="container?.containerType + '-icon'">
            </div>
            <div class="container-type-information-text-container">
                <span>{{
                        'project.components.containerSummary.containerTypes.'
                        + container?.containerType | translate
                    }}</span>
            </div>
        </div>

        <div class="container-name-wrapper">
            <span>{{ container.name }}</span>
        </div>

        <div class="container-information-wrapper">
            <div class="container-image-wrapper left-side">
                <img [src]="imageUrl" alt="container">
            </div>
            <div class="container-description-wrapper right-side"
                 [innerHTML]="container?.description | newLineToBr">
            </div>
        </div>

        <div class="footer-wrapper">
            <div class="container-owner-information-wrapper left-side">
                <app-user-info
                    *ngIf="userInfo"
                    [userInfo]="userInfo"
                    [containerType]="container?.containerType"
                ></app-user-info>
            </div>
            <div class="container-functions-wrapper right-side">
                <div class="join-container-wrapper" *ngIf="canJoinContainer">
                    <div class="checkbox-wrapper">
                        <div class="checkbox-container">
                            <input
                                id="container-summary-accept-terms"
                                type="checkbox"
                                class="custom-checkbox-input"
                                [(ngModel)]="termsAccepted">
                            <label
                                for="container-summary-accept-terms"
                                class="custom-checkbox-label">
                                <img src="assets/svg/checkmark-pink.svg"
                                     alt="checkmark-icon"
                                     class="checkmark-icon">
                            </label>
                        </div>
                        <div class="text-container">
                            <span
                                class="accept-terms-text">{{ 'project.components.containerSummary.acceptTermsText' | translate }}</span>
                        </div>
                    </div>
                    <div class="button-wrapper button-wrapper-tryb-button">
                        <button
                            id="container-summary-join-container-button"
                            type="button"
                            class="button-tryb-button standard-tryb-button"
                            (click)="onRequestToJoinClick()"
                            [disabled]="!termsAccepted"
                            [title]="getJoinButtonTooltip() | translate"
                        >
                            {{
                                getJoinButtonTranslationKey()
                                    | translate
                            }}
                        </button>
                    </div>
                </div>
                <div class="visit-container-wrapper" *ngIf="canVisitContainer">
                    <div class="button-wrapper button-wrapper-tryb-button">
                        <button
                            id="container-summary-visit-container-button"
                            type="button"
                            class="button-tryb-button standard-tryb-button"
                            (click)="onVisitContainerClick()"
                        >
                            {{
                                getVisitButtonTranslationKey()
                                    | translate
                            }}
                        </button>
                    </div>
                </div>
                <div class="requested-to-join-container-wrapper" *ngIf="isMembershipRequested">
                    <span
                        class="requested-to-join-text">{{ 'project.components.containerSummary.messages.requestedToJoin' | translate }}</span>
                </div>
            </div>
        </div>
    </div>
</div>
